module.exports = __webpack_public_path__ + "static/media/arrow-buttons.4dcc98a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/arrow-buttons.svg
// module id = 628
// module chunks = 0